import styled from '@emotion/styled';
import rem from '../../utils/rem/rem';

interface StyledProps {
  disabled?: boolean;
}

export const StyledRadio = styled.li`
  color: ${({ theme }) => theme.colors.gray900};
  position: relative;
  display: inline-flex;
  align-items: center;
  font-family: 'Open Sans';
  font-size: ${rem(14)};
  list-style-type: none;
  margin: 0;
`;

// input uses px instead of rem because internal svg cannot use rem for position or radius of the circle
export const StyledInput = styled.input`
  width: 20px;
  height: 20px;
  box-sizing: border-box;
  border-radius: 50%;
  margin: 0;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  border: 1px solid ${({ theme }) => theme.colors.gray900};

  &:checked {
    border: 2px solid ${({ theme }) => theme.colors.gray900};
  }

  &:hover {
    border: 2px solid ${({ theme }) => theme.colors.gray900};
  }

  &:checked + svg {
    display: block;
    position: absolute;
    top: calc(50% - 10px);
    left: 0;
  }

  &:not(:checked) + svg {
    display: none;
  }

  &:focus {
    outline: 2px dashed ${({ theme }) => theme.colors.red};
    outline-offset: 2px;
  }

  &[aria-disabled='true'] {
    border: 1px solid ${({ theme }) => theme.colors.gray400};
    background-color: ${({ theme }) => theme.colors.gray100};
    pointer-events: none;
  }
`;

export const StyledLabel = styled.label<StyledProps>`
  pointer-events: ${({ disabled }) => (disabled ? 'none' : '')};
  padding-left: ${rem(8)};
`;
